import React from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'
import { ZipCodeTW } from "zipcode-tw-react";
import { withTranslation } from 'react-i18next';
import { updateMemberInfo } from '../actions/asyncMember'
import { withRouter } from "react-router";

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Select from '@material-ui/core/Select'
import OutlinedInput from '@material-ui/core/OutlinedInput'

import Loading from './Loading'
import AddCreditCardDialog from './dialog/AddCreditCardDialog'
import UpdateInvoiceDialog from './dialog/UpdateInvoiceDialog'
import UpdatePhone from './dialog/UpdatePhone'
import { parseLoactionSearch } from 'libraries/utils'

const TAB_INFO = 'info'
const TAB_CARD = 'card'

class Setting extends React.Component {
    constructor(props) {
        super(props)
        const formatAddress = props.memberInfo.formatAddress || {};
        const search = parseLoactionSearch()
        this.state = {
            memberId: '',
            memberSha: '',
            name: props.memberInfo.realName || '',
            country: formatAddress.city || '',
            district: formatAddress.area || '',
            zip: formatAddress.zipCode || '',
            gender: props.memberInfo.gender || 'F',

            isOpenAddCreditCardDialog: search.update === 'true' || props.location.state === 'updatecard' || false,
            isOpenUpdatePhoneDialog: false,
            isOpenUpdateInvoiceDialog: false,
        }
    }

    handleOnClickTab = (tabId) => {
        this.props.history.push(`/member/setting/${tabId}`)
    }

    handleOnSubmit = () => {
        const { name, currency, address, country, district, zip, gender } = this.state
        this.props.updateMemberInfo({
            realName: name,
            currency,
            gender,
            addressZipCode: zip,
            addressCity: country,
            addressArea: district,
            addressAddress: address
        })
    }

    handleOnOpenAddCreditCard = () => {
        this.setState({
            isOpenAddCreditCardDialog: !this.state.isOpenAddCreditCardDialog
        })
    }

    handleOnOpenUpdatePhone = () => {
        this.setState({
            isOpenUpdatePhoneDialog: !this.state.isOpenUpdatePhoneDialog
        })
    }

    handleOpenUpdateInvoiceDialog = () => {
        this.setState({
            isOpenUpdateInvoiceDialog: !this.state.isOpenUpdateInvoiceDialog
        })
    }

    updateInvoice = (value) => {
        this.props.updateMemberInfo({ receiptTitle: '', receiptTaxId: '', ...value })
        this.handleOpenUpdateInvoiceDialog()
    }

    handleOnChange = type => e => {
        this.setState({
            [type]: e.target.value
        })
    }

    handleChangeZipCode = ({
        countyValue,
        districtValue,
        zipValue
    }) => {
        this.setState({
            country: countyValue,
            district: districtValue,
            zip: zipValue
        })
    }

    render() {
        const { t, isLoading, match: { params: { tabId } }, memberInfo } = this.props
        const {
            name,
            country,
            district,
            gender,
            isOpenAddCreditCardDialog,
            isOpenUpdatePhoneDialog,
            isOpenUpdateInvoiceDialog
        } = this.state
        const isActivedInfo = tabId === TAB_INFO
        const isActivedCard = tabId === TAB_CARD
        const formatAddress = memberInfo.formatAddress || {};
        const creditCard = memberInfo.creditCardLastFour ? `···· ···· ···· ${memberInfo.creditCardLastFour}` : null
        const receiptType = memberInfo.receiptType === 2 ? "二聯式紙本發票" : (memberInfo.receiptType === 3 ? "三聯式紙本發票" : null)
        const receiptTitle = memberInfo.receiptType === 3 && memberInfo.receiptTitle ? `${t('receipt_title')} : ${memberInfo.receiptTitle}` : null
        const receiptTaxId = memberInfo.receiptType === 3 && memberInfo.receiptTaxId ? `${t('tax_id')} : ${memberInfo.receiptTaxId}` : null

        return (
            <Grid container className="setting" justify="center">
                <Loading isLoading={isLoading} />
                <Grid item md={8}>
                    <Typography component="h1" variant="h1">{t('setting')}</Typography>
                    <Grid container className="tabs">
                        <div
                            className={cn('tab', { 'tab-active': isActivedInfo })}
                            onClick={() => this.handleOnClickTab(TAB_INFO)}
                        >
                            <Typography
                                className="tab-name"
                                color={isActivedInfo ? "primary" : "initial"}
                            >
                                {t('basic_setting')}
                            </Typography>
                        </div>
                        <div
                            className={cn('tab', { 'tab-active': isActivedCard })}
                            onClick={() => this.handleOnClickTab(TAB_CARD)}
                        >
                            <Typography
                                className="tab-name"
                                color={isActivedCard ? "primary" : "initial"}
                            >
                                {t('credit_card_setting')}
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container className={cn('tab-cont', { 'hidden': !isActivedInfo })}>
                        <Grid item md={10}>
                            <Grid container alignItems="center" style={{ marginBottom: '10px' }}>
                                <Grid item md={3}>
                                    <Typography className="text-grey">{t('phone')}</Typography>
                                </Grid>
                                <Grid item md={5}>
                                    <Grid container alignItems="center">
                                        <TextField
                                            margin="dense"
                                            name="phone"
                                            id="phone"
                                            variant="outlined"
                                            value={memberInfo.phone}
                                            disabled
                                            fullWidth
                                            style={{ backgroundColor: 'rgba(74, 79, 85, 0.1)' }}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid item md={3}>
                                    <Typography
                                        color="primary"
                                        className="pointer"
                                        style={{ marginLeft: '10px' }}
                                        onClick={this.handleOnOpenUpdatePhone}
                                    >
                                        {t('re_verify')}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid container alignItems="center" style={{ marginBottom: '10px' }}>
                                <Grid item md={3}>
                                    <Typography className="text-grey">Email</Typography>
                                </Grid>
                                <Grid item md={5}>
                                    <TextField
                                        margin="dense"
                                        name="email"
                                        id="email"
                                        variant="outlined"
                                        value={memberInfo.email}
                                        disabled
                                        fullWidth
                                        style={{ backgroundColor: 'rgba(74, 79, 85, 0.1)' }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container alignItems="center" style={{ marginBottom: '20px' }}>
                                <Grid item md={3}>
                                    <Typography className="text-grey">{t('real_name')}</Typography>
                                </Grid>
                                <Grid item md={5}>
                                    <TextField
                                        margin="dense"
                                        name="name"
                                        id="name"
                                        variant="outlined"
                                        fullWidth
                                        value={name}
                                        onChange={this.handleOnChange('name')}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container alignItems="center" style={{ marginBottom: '20px' }}>
                                <Grid item md={3}>
                                    <Typography className="text-grey">{t('gender')}</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Select
                                        native
                                        id="gender"
                                        name="gender"
                                        input={
                                            <OutlinedInput fullWidth labelWidth={0} margin="dense" />
                                        }
                                        onChange={this.handleOnChange('gender')}
                                        value={gender}
                                    >
                                        <option value={'F'}>{t('female')}</option>
                                        <option value={'M'}>{t('male')}</option>
                                    </Select>
                                </Grid>
                            </Grid>
                            <Grid container alignItems="center" style={{ marginBottom: '5px' }}>
                                <Grid item md={3}>
                                    <Typography className="text-grey">{t('address')}</Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <ZipCodeTW
                                        displayType="text"
                                        countyClass="zip-code"
                                        districtClass="zip-code"
                                        zipStyle={{ display: 'none' }}
                                        handleChangeCounty={this.handleChangeZipCode}
                                        handleChangeDistrict={this.handleChangeZipCode}
                                        countyValue={country}
                                        districtValue={district}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container alignItems="center" style={{ marginBottom: '20px' }}>
                                <Grid item md={3}>
                                </Grid>
                                <Grid item md={9}>
                                    <TextField
                                        margin="dense"
                                        name="address"
                                        id="address"
                                        variant="outlined"
                                        fullWidth
                                        defaultValue={formatAddress.address || ''}
                                        onChange={this.handleOnChange('address')}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container alignItems="center" style={{ marginBottom: '20px' }}>
                                <Grid item md={3}>
                                    <Typography className="text-grey">{t('currency')}</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Select
                                        native
                                        id="currency"
                                        name="currency"
                                        input={
                                            <OutlinedInput fullWidth labelWidth={0} margin="dense" />
                                        }
                                        onChange={this.handleOnChange('currency')}
                                    >
                                        <option value={'TWD'}>{t('TWD')}</option>
                                    </Select>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container justify="flex-end">
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={this.handleOnSubmit}
                            >
                                {t('save')}
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid container className={cn('tab-cont', 'bill-info', { 'hidden': !isActivedCard })}>
                        <Grid container>
                            <Grid container style={{ marginBottom: '13px' }}>
                                <Typography className="text-grey">
                                    {t('payment_method')}
                                </Typography>
                                <Typography color="primary" variant="body2"
                                    className="edit-link pointer"
                                    onClick={this.handleOnOpenAddCreditCard}
                                >
                                    {t('update_credit_card')}
                                </Typography>
                            </Grid>
                            <Grid container style={{ marginBottom: '32px' }}>
                                <Typography style={{ lineHeight: '30px' }}>
                                    {t('credit_card')} {creditCard}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid container style={{ marginBottom: '13px' }}>
                                <Typography className="text-grey">
                                    {t('invoice_info')}
                                </Typography>
                                <Typography color="primary" variant="body2"
                                    className="edit-link pointer"
                                    onClick={this.handleOpenUpdateInvoiceDialog}
                                >
                                    {t('update_invoice_info')}
                                </Typography>
                            </Grid>
                            <Grid container className="cont" style={{ marginBottom: '32px' }}>
                                <Typography style={{ lineHeight: '30px' }}>
                                    {receiptType} <br />
                                    {receiptTitle} <br />
                                    {receiptTaxId}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <UpdatePhone
                    open={isOpenUpdatePhoneDialog}
                    onClose={this.handleOnOpenUpdatePhone}
                />
                <AddCreditCardDialog
                    open={isOpenAddCreditCardDialog}
                    onClose={this.handleOnOpenAddCreditCard}
                />
                <UpdateInvoiceDialog
                    open={isOpenUpdateInvoiceDialog}
                    onClose={this.handleOpenUpdateInvoiceDialog}
                    onSubmit={this.updateInvoice}
                />
            </Grid>
        )
    }
}

const mapStateToProps = state => ({
    memberInfo: state.member.member,
    isLoading: state.member.isLoading
})

const mapDispatchToProps = {
    updateMemberInfo,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(withTranslation()(Setting)))